// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"333":"1cbc567f","518":"2a81ab6d"}[chunkId] + ".chunk.css";
};